module.exports = __webpack_public_path__ + "static/media/template.19b24685.svg";